export default {
  minimal: 300,
  small: 400,
  medium: 725,
  large: 560,
}



// WEBPACK FOOTER //
// ./src/theme/screens.js